import cx from 'classnames';
import {
  ConfirmationModal as AdminConfirmationModal,
  IConfirmationModalProps,
} from 'components/admin/ui';
import css from './ConfirmationModal.module.scss';

const ConfirmationModal = ({ className, ...rest }: IConfirmationModalProps) => (
  <AdminConfirmationModal
    backdrop="static"
    centered={false}
    className={cx(css.modal, className)}
    backdropClassName={css.backdrop}
    {...rest}
  />
);

ConfirmationModal.Body = AdminConfirmationModal.Body;
ConfirmationModal.Confirmation = AdminConfirmationModal.Confirmation;
ConfirmationModal.Footer = AdminConfirmationModal.Footer;
ConfirmationModal.Header = AdminConfirmationModal.Header;
ConfirmationModal.Icon = AdminConfirmationModal.Icon;

export { ConfirmationModal };
